import { combineReducers } from 'redux';
import zone from './zone';
import points from './points';

export const aastPlanReducer = combineReducers({
  zone,
  points,
});



// WEBPACK FOOTER //
// ./src/modules/saas/aast/zones/plan/reducers/index.js